package uz.ferro.shop.model

enum class DeliveryType {
    PICKUP_POINT,
    ADDRESS
}
